import React from 'react';
import LoadingButton from '@atlaskit/button/loading-button';
import { useIntl } from '@atlassian/jira-intl';
import { useFormState } from '../../../controllers';
import messages from './messages';

export const SaveButton = () => {
	const [{ savingInProgress, modified }, { save }] = useFormState();
	const { formatMessage } = useIntl();
	return (
		<LoadingButton
			appearance="primary"
			onClick={save}
			isDisabled={!modified}
			isLoading={savingInProgress}
		>
			{formatMessage(messages.saveChanges)}
		</LoadingButton>
	);
};
